import Navbar from "layout/navbar/Navbar";
import React from "react";
import Footer from "shared/Footer";
import styled from "styled-components";

const WebLayout = ({ children }) => {
  return (
    <div>
      <Navbar />
      <WebContent>{children}</WebContent>
      <Footer />
    </div>
  );
};

export default WebLayout;

const WebContent = styled.div`
  flex: 1;
  overflow-y: scroll;
  height: 100%;
  background-color: #ffffff;
`;
